var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0096 10.1719L21.0122 13.7948C20.9867 14.1399 20.9538 14.4846 20.9136 14.8287C20.8463 15.4042 20.3785 15.8683 19.7911 15.9339C17.9514 16.1396 16.0476 16.1396 14.2078 15.9339C13.6204 15.8683 13.1527 15.4042 13.0854 14.8287C12.8656 12.9497 12.8656 11.0515 13.0854 9.1725C13.1527 8.59709 13.6204 8.13295 14.2078 8.0673C16.0476 7.86168 17.9514 7.86168 19.7911 8.0673C20.3785 8.13295 20.8463 8.59709 20.9136 9.1725C20.9525 9.50511 20.9845 9.83831 21.0096 10.1719ZM16.9995 10.5006C16.171 10.5006 15.4995 11.1722 15.4995 12.0006C15.4995 12.829 16.171 13.5006 16.9995 13.5006C17.8279 13.5006 18.4995 12.829 18.4995 12.0006C18.4995 11.1722 17.8279 10.5006 16.9995 10.5006Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4031 6.04034C20.5586 6.3096 20.2667 6.61112 19.9577 6.57658C18.0073 6.35859 15.9917 6.35859 14.0412 6.57658C12.7718 6.71845 11.7453 7.71799 11.5955 8.99825C11.3622 10.993 11.3622 13.0082 11.5955 15.003C11.7453 16.2833 12.7718 17.2828 14.0412 17.4247C15.9917 17.6427 18.0073 17.6427 19.9577 17.4247C20.2688 17.3899 20.563 17.6935 20.406 17.9643C19.6274 19.3071 18.2393 20.2443 16.6263 20.414L15.9744 20.4826C12.6636 20.831 9.32413 20.8081 6.01838 20.4141L5.58644 20.3627C3.80431 20.1503 2.39226 18.7579 2.15489 16.979C1.714 13.6747 1.714 10.3265 2.15489 7.02227C2.39226 5.24331 3.80431 3.85095 5.58643 3.63859L6.01837 3.58712C9.32413 3.19319 12.6636 3.17022 15.9744 3.51862L16.6263 3.58722C18.2407 3.7571 19.6266 4.69571 20.4031 6.04034Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletWhite);
export default __webpack_public_path__ + "static/media/wallet-white.3105363e74e2e424c1e7f96fcd30c640.svg";
export { ForwardRef as ReactComponent };